// GTM dataLayer utility — push events to Google Tag Manager
window.dataLayer = window.dataLayer || [];

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getAnalyticsSession() {
  let id = sessionStorage.getItem("nfw_analytics_sid");
  if (!id) {
    id = `s_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem("nfw_analytics_sid", id);
  }
  return id;
}

function genConversionId(prefix) {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).substr(2, 8)}`;
}

export function gtmEvent(event, params = {}) {
  window.dataLayer.push({ event, ...params });
}

// Virtual pageview — call on every route change
export function gtmPageView(path, title) {
  gtmEvent("virtual_page_view", {
    page_path: path,
    page_title: title || document.title,
  });
  // Reddit Pixel — track page visit on SPA route change
  if (window.rdt) window.rdt('track', 'PageVisit', { conversionId: genConversionId('pv') });
  // Server-side tracking
  fetch(`${API}/analytics/pageview`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ path, referrer: document.referrer, session_id: getAnalyticsSession() }),
  }).catch(() => {});
}

// Form submissions
export function gtmFormSubmit(formName, extraData = {}) {
  gtmEvent("form_submit", { form_name: formName, ...extraData });
  // Reddit Pixel — track Lead with advanced matching
  if (window.rdt) {
    if (extraData.email) window.rdt('init', 'a2_isacxcremahl', { email: extraData.email });
    window.rdt('track', 'Lead', { conversionId: genConversionId('lead') });
  }
}

// CTA / button clicks
export function gtmClick(label, category = "cta") {
  gtmEvent("cta_click", { click_label: label, click_category: category });
}

// Purchase funnel
export function gtmPurchaseStep(step, stepName, data = {}) {
  gtmEvent("purchase_step", { step_number: step, step_name: stepName, ...data });
  fetch(`${API}/analytics/event`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ event: "purchase_step", step_number: step, step_name: stepName, session_id: getAnalyticsSession(), ...data }),
  }).catch(() => {});
}

export function gtmBeginCheckout(packageName, total, addons = []) {
  gtmEvent("begin_checkout", {
    package_name: packageName,
    cart_total: total,
    addons: addons.join(", "),
  });
}

export function gtmPurchaseComplete(packageName, total, ticketNumber, email) {
  gtmEvent("purchase", {
    package_name: packageName,
    transaction_total: total,
    ticket_number: ticketNumber,
  });
  // Reddit Pixel — track Purchase with advanced matching
  if (window.rdt) {
    if (email) window.rdt('init', 'a2_isacxcremahl', { email });
    window.rdt('track', 'Purchase', { conversionId: genConversionId('purchase'), value: total, currency: 'AUD' });
  }
}

// Phone clicks
export function gtmPhoneClick(location) {
  gtmEvent("phone_click", { click_location: location });
}

// Chatbot
export function gtmChatOpen() {
  gtmEvent("chatbot_open");
}

export function gtmChatMessage(messageCount) {
  gtmEvent("chatbot_message", { message_count: messageCount });
}
